import { Component, OnInit } from "@angular/core";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonService } from "src/app/services/common.service";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import * as SecureLS from "secure-ls";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ExcelServicesService } from "../../../services/excel.service";
import { StorageService } from "../../../services/storage.service";

@Component({
  selector: "app-daily-report",
  templateUrl: "./daily-report.component.html",
  styleUrls: ["./daily-report.component.css"],
})
export class DailyReportComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  total_count = 0;
  video: any;
  vid: any;
  maxDate = new Date();
  getVideo: any;
  videoList: any[] = [];
  searchForm: FormGroup;
  uivideoList: any;
  excelVideoList: any[];
  filter_from: any;
  filter_end: any;
  prolength: number = 0;
  form: FormGroup;
  batch_id: string;
  filter: any;
  classroom: any;
  class: any;
  batch: any;
  total: number;
  batchData1: any;
  videoList1: any;
  recrange: any;
  pageno: any;
  offset: number =1;
  dropbox: any[];
  check: number;
  filtervalues: boolean;
  chiparray = [];
  htmlpageshow: boolean;
  pageshow: boolean = true;
  page_count: any[];
  countvalue: number = 0;
  pagedItems: any[];
  page: number = 1;
  p: number;
  limit: number = 10;
  selectedList: any;
  department_id: any;
  department: any;
  dept: any;
  hod: any;
  sessionData: any;
  minDate: Date;
  findedVal: any;
  professorname: Object;
  professorData: any;
  professor_id: any;
  role: number;
  constructor(
    private storageService: StorageService,
    private datepipe: DatePipe,
    public globalService: GlobalService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private ExcelServicesService: ExcelServicesService,
    public commonService: CommonService

  ) {
    this.role = this.storageService.getRole();
    this.hod = this.storageService.getHod();
  }
  async ngOnInit() {
    this.maxDate = new Date();
    this.minDate = new Date();
    this.searchForm = this.fb.group({
      id: [""],
      date: ["", [Validators.required]],
      batchname: [null],
      depname: [null],
      proname: [""],
      session: [null],
    });
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
    }
    
    if (this.storageService.getRole() == 4 && this.hod !== 1 ) {
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].setValue(this.professor_id);
      this.searchForm.controls["proname"].disable();
    }
    await this.getBatch();
    await this.getProfessor();
    await this.getDepartment();   
    await this.getSession();
  }

  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );

    this.dept = this.department["content"];
    this.spinner.hide();
  }

  async getProfessor() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.professorname = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );
   
    this.professorData = this.professorname["content"];
    if (this.storageService.getRole() == 4 && this.hod !== 1) {
      this.professor_id = this.storageService.getProfessor();
    }
    this.spinner.hide();
  }


  get forms() {
    return this.searchForm.controls;
  }
  async getPage(page: number) {
    this.offset = page;
    await this.getVideoDetails();
    const res = await this.serverCall(this.videoList, page);
    this.total = this.countvalue;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.limit;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  getvalue(event: any, rec: any, offset: number) {
    this.recrange = rec;
    this.pageno = event;
    this.offset = offset;
    this.exportAsXLSX();
  }
 
  async dropboxdown() {
    this.dropbox = [];
    var count = 1000,
      offset = 0,
      tempcount = 1000,
      c1,
      c2;
    this.check = Math.ceil(this.countvalue / count);
    var cvar = 1;
    for (let i = 1; i <= this.check; i++) {
      c1 = cvar;
      c2 = count;
      cvar = cvar + tempcount;
      count += tempcount;
      this.dropbox.push({ value: i, records: c1 + "-" + c2, offset: offset });
      offset = offset + 1000;
    }
  }

  async getSession() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    let session = await this.globalService.get(
      "session/dropdown",
      filter,
      true
    );

    this.sessionData = session["content"];
    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    
    this.findedVal = this.sessionData.find(
      (list) => list.session === this.searchForm.controls['session']?.value
    );
    this.onSessionChangeEvent(true);
    this.Filter();
    this.spinner.hide();
  }

  onSessionChangeEvent(isInitLoad?) {
    this.forms["date"].setValue(null);
    this.getFilterDate(null);
    let sessionVal = this.forms["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData.find(
        (list) => list.session === sessionVal
      );
      this.minDate.setDate(new Date(this.findedVal.start_date).getDate());
      this.minDate.setMonth(new Date(this.findedVal.start_date).getMonth());
      this.minDate.setFullYear(
        new Date(this.findedVal.start_date).getFullYear()
      );
      this.maxDate.setDate(new Date(this.findedVal.end_date).getDate());
      this.maxDate.setMonth(new Date(this.findedVal.end_date).getMonth());
      this.maxDate.setFullYear(new Date(this.findedVal.end_date).getFullYear());
      if (isInitLoad) {
        let splitedChipArray = null;
        if(this.chiparray.length){
          this.chiparray.forEach((elem)=>{
            if(elem.split(" : ")[0] === "Date" ){
              splitedChipArray =  elem.split(" : ")[1].split(" - ");
            }
          })
        }
        if(splitedChipArray?.length){
          const convertedDates = splitedChipArray.map(dateStr => new Date(dateStr));
          this.forms["date"].setValue(convertedDates);
          this.getFilterDate(convertedDates);
        }else{
        this.forms["date"].setValue([new Date(), new Date()]);
        this.getFilterDate([new Date(), new Date()]);
      }
    }
    } else {
      this.forms["date"].setValue(null);
      this.getFilterDate(null);
    }
  }

  getFilterDate(filter_date) {
    if (filter_date) {
      this.filter = filter_date;

      this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD");
      this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD");
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
            new Date(this.filter_end).getTime()
        ) / oneDay;
      if (-diffDays > 365) {
        Swal.fire({
          text: "Please select dates within 1 year",

          icon: "warning",

          confirmButtonText: "OK",

          confirmButtonColor: "#808080",
        });
      }
    }
  }
  async getBatch() {
    this.videoList = [];
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.batch = await this.globalService.get(
      "batch/list/dropdown",
      filter,
      true
    );

    this.batchData1 = this.batch["content"];
    this.spinner.hide();
  }

  async getVideoDetails() {
    this.videoList = [];
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      start_date: this.filter_from || moment(new Date()).format("YYYY-MM-DD"),
      end_date: this.filter_end || moment(new Date()).format("YYYY-MM-DD"),
      batch_id: this.batch_id,
      professor_id: this.professor_id? this.professor_id : this.searchForm.controls["proname"].value,
      department_id: this.department_id?this.department_id:this.searchForm.controls["depname"].value,
      session_id: this.findedVal?.id,
      offset: this.offset,
      limit: this.limit,
    };
    this.getVideo = await this.globalService.get(
      "classVideoDetail/summary/overall",
      filter
    );
    const dateKeyExists = this.chiparray.some((chip) => chip.startsWith("Date :"));

    if (!dateKeyExists) {
      this.chiparray.push("Date :" + " " + filter.start_date + " - " + filter.end_date);
    }

    this.videoList = this.getVideo["content"]["rows"];

    this.countvalue = this.getVideo["content"].count;

    this.videoList1 = [];
    this.videoList.map((item) => {
      this.videoList1.push(item);
    });

    if (this.getVideo["status"] === 200) {
      this.pageshow = true;

      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.countvalue / this.limit);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    } else {
      this.videoList = [];
      this.spinner.hide();
    }
    (error) => {
      this.videoList = [];
      this.spinner.hide();
    };
    this.spinner.hide();
    this.dropboxdown();
  }

  async exportAsXLSX(): Promise<void> {
    this.spinner.show();
    var count = 1000;
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      start_date: this.filter_from || moment(new Date()).format("YYYY-MM-DD"),
      end_date: this.filter_end || moment(new Date()).format("YYYY-MM-DD"),
      batch_id: this.batch_id,
      department_id: this.department_id,
      // professor_id: this.professor_id? this.professor_id : this.searchForm.controls["proname"].value,
      // department_id: this.department_id?this.department_id:this.searchForm.controls["depname"].value,
      offset: this.offset ? this.offset : 0,
      limit: count,
      isdownload: true,
      session_id: this.findedVal?.id,
    };
    this.getVideo = await this.globalService.get(
      "classVideoDetail/summary/overall",
      filter
    );
    this.excelVideoList = this.getVideo["content"];
    this.uivideoList = this.excelVideoList.map((item: any) => {
      return {
        CLASS_ROOM_NAME: item.class_name,
        INACTIVE_VIDEOS: item.inactive_video,
        VIDEOS_COMPLETED: item.video_completed,
        NOT_COMPLETED_VIDEOS: item.noncaptured_video,
        NON_AUDIBLE_VIDEOS: item.nonaudible_video,
        VIDEOS_APPROVED: item.video_approved,
        TOTAL_VIDEOS: item.video_total,
      };
    });
    this.ExcelServicesService.exportAsExcelFile(
      this.uivideoList,
      `overall_summary_Report_from_${this.filter_from}_to_${this.filter_end}`,
      true
    );
    this.offset = 1;
    this.recrange = "";
    this.spinner.hide();
  }

  openScrollableContent(longContent) {
    this.findedVal = null;
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
    // this.searchForm.reset();
    if(!this.forms["session"].value){
    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );}
    this.onSessionChangeEvent(true);
    if (this.storageService.getRole() === 4 && this.hod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
    }
    if (this.storageService.getRole() === 4 && this.hod !== 1) {
      this.searchForm.controls["proname"].setValue(
        this.storageService.getProfessor()
      );
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].disable(); 
    }
  }

  async openXl(content, selectedList, summary_type) {
    this.selectedList = { ...selectedList, department_id: this.department_id, professor_id: this.professor_id, session_id:this.findedVal?.id, summary_type: summary_type };
    this.modalService.open(content, { size: "xl" });
  }
  loadMore(index) {
    this.pageshow = true;
    this.offset = index;
    this.getVideoDetails();
  }
  previous() {
    this.pageshow = true;
    this.offset = this.offset - 1;
    this.getVideoDetails();
  }
  next() {
    this.pageshow = true;
    this.offset = this.offset + 1;
    this.getVideoDetails();
  }

  Filter() {
    this.filtervalues = true;
    this.chiparray = [];
    if(this.searchForm.controls["session"]?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.controls["session"]?.value
      );
    }
  
    if (this.professor_id != undefined && this.professor_id != "") {
      var proffessor = this.professorData.filter(
        (x) => x.id == this.professor_id
      );
      if (proffessor.length > 0 && proffessor[0]) {
        this.chiparray.push(
          "Proff:" +
            " " +
            proffessor[0].first_name +
            " " +
            proffessor[0].last_name
        );
      }
    }
    if (this.batch_id != undefined && this.batch_id != "") {
      var batch = this.batchData1.filter((x) => x.id == this.batch_id);
      this.chiparray.push("Batch:" + " " + batch[0].batch);
    }
    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }
    this.batch_id = this.searchForm.controls['batchname']?.value;
    this.department_id =  this.department_id ? this.department_id : this.searchForm.controls["depname"]?.value;    
    this.pageshow = true;
    this.offset = 1;
    this.getVideoDetails();
  }
  res() {
    this.forms["date"].setValue(null);
    this.getFilterDate(null);
    this.chiparray = [];
    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.findedVal = this.sessionData?.find(
      (list) => list.session === this.searchForm.controls["session"]?.value
    ) || null;
    this.chiparray.push(
      "Session : " + this.searchForm.controls["session"]?.value
    );
    this.filtervalues = false;
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
      this.professor_id = null;}
      if (this.storageService.getRole() == 4 && this.hod != 1) {
      var proff = this.professorData.filter((x) => x.id == this.professor_id);
      if (proff.length > 0 && proff[0]) {
        this.chiparray.push("Proff:" + " " + proff[0].first_name + " " +proff[0].last_name);
      }
      this.department_id = null;
    }

    if (this.storageService.getRole() != 4) {
      this.department_id = null;
      this.professor_id = null;
    }
    this.forms["date"].setValue([new Date(), new Date()]);
    this.getFilterDate([new Date(), new Date()]);
    this.batch_id = null;
    this.videoList = null;
    this.videoList1 = [];
    this.prolength = 0;
    this.countvalue = 0;
    this.htmlpageshow = false;
    this.searchForm.reset();
    this.getVideoDetails();
    this.pageshow = true;
    this.offset = 1;
  }
  paginationCount(value) {
    this.offset = 1;
    this.limit = value;
    this.getVideoDetails();
  }
}
